import React from 'react';
import {
  Box,
  Typography
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

const EmptyState = ({ 
  icon = <AddIcon sx={{ fontSize: 40, color: 'text.secondary' }} />,
  title = "No data found",
  description = "Try adjusting your filters or add your first item.",
  actionButton = null
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      py: 8,
      textAlign: 'center'
    }}>
      <Box sx={{ 
        width: 80, 
        height: 80, 
        borderRadius: '50%', 
        backgroundColor: 'grey.100',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 3
      }}>
        {icon}
      </Box>
      <Typography variant="h6" sx={{ mb: 1, color: 'text.secondary' }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
        {description}
      </Typography>
      {actionButton}
    </Box>
  );
};

export default EmptyState; 